import { render, staticRenderFns } from "./backend.vue?vue&type=template&id=23b43146&"
import script from "./backend.vue?vue&type=script&lang=js&"
export * from "./backend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports